class ContentTabs extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', this.onTabClick.bind(this))
  }
  onTabClick(e) {
    const target = e.target
    if (target.hasAttribute('data-tab-title')) {
      const tabIndex = target.dataset.tabTitle
      const tabs = target.parentElement.querySelectorAll('.tab__title')
      const activeTab = this.querySelector(`[data-tab-content="${tabIndex}"]`)
      const content = activeTab.parentElement.querySelectorAll('.tab__content')

      target.classList.add('active')
      activeTab.classList.remove('hidden')

      tabs.forEach((tab) =>
        tab !== target ? tab.classList.remove('active') : ''
      )
      content.forEach((item) =>
        item !== activeTab ? item.classList.add('hidden') : ''
      )
    }
  }
}

customElements.define('content-tabs', ContentTabs)
